import styled from 'styled-components';

export const EmptyStateText = styled.h1`
  font-size: 18px;
`;

export const EmptyStateIcon = styled.img`
  height: 70px;
  width: 70px;
`;

export const CenteredEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
